export default __webpack_public_path__ + "static/media/polygon.6ff3605e.svg";